export default {
    Auth: {
        // REQUIRED - Amazon Cognito Region
        region: process.env.VUE_APP_AWS_Region,

        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: process.env.VUE_APP_AWS_identityPoolId,

        // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
        // Required only if it's different from Amazon Cognito Region
        // identityPoolRegion: 'us-west-2',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: process.env.VUE_APP_AWS_userPoolId,

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: process.env.VUE_APP_AWS_userPoolWebClientId,

        // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
        // 
        // authenticationFlowType: 'CUSTOM_AUTH'

        oauth: {
            // Domain name
            domain: process.env.VUE_APP_OAUTH_domain,

            // Authorized scopes
            scope: ["openid", "email", "profile"],

            // Callback URL
            redirectSignIn: process.env.VUE_APP_OAUTH_redirectURL, // localhost

            // Sign out URL
            redirectSignOut: process.env.VUE_APP_OAUTH_redirectURL, // localhost

            // 'code' for Authorization code grant, 
            // 'token' for Implicit grant
            // Note that REFRESH token will only be generated when the responseType is code
            responseType: 'code',

            options: {
                AdvancedSecurityDataCollectionFlag: false
            }
        }
    },
    Storage: {
        AWSS3: {
            bucket: process.env.VUE_APP_AWS_BucketName, //REQUIRED -  Amazon S3 bucket
            region: process.env.VUE_APP_AWS_Region, //OPTIONAL -  Amazon service region
            identityPoolId: process.env.VUE_APP_AWS_identityPoolId,
        }
    },
    API: {
        endpoints: [
            {
                name: process.env.VUE_APP_APIName,
                endpoint: process.env.VUE_APP_APIEndPoint,
            },
            {
                name: process.env.VUE_APP_APIAPPNameQA,
                endpoint: process.env.VUE_APP_APIAPPEndPointQA,
            },
        ]
    }
}